import { AbstractIntlMessages } from 'next-intl';

export enum languageEnum {
  'en-US' = 'en-US',
  // 'zh-CN' = 'zh-CN',
}
export type Language = keyof typeof languageEnum;
export type LanguageParams = { locale: Language };
export type LanguageAsyncParams = { params: Promise<LanguageParams> };
export type MessagesParams = { messages: AbstractIntlMessages };
export const fallbackLng = languageEnum['en-US'];
export const languages: Language[] = ['en-US'];
export const languagesRegExpMatcher = `${languages.join('|')}`;
